import {useDispatch, useSelector} from 'react-redux';

import {useAccountSettingsState} from './api';
import {
  DashboardIsOpenPayloadType,
  toggleSidebarIsOpen,
  toggleWidgetIsOpen,
} from './slice';

import type {WidgetIsOpenPayloadType} from './slice';

export function useSwitch(switchName: string): boolean {
  return useAccountSettingsState().data?.switches[switchName] || false;
}

export function useWidgetIsOpenState({
  contentType,
  objectId,
  widgetName,
  defaultValue = true,
}: Partial<WidgetIsOpenPayloadType>) {
  const key = `${contentType} ${objectId} ${widgetName}`;
  // default true because why not?
  return useSelector(
    (state) => state.settings.widgetIsOpen[key] ?? defaultValue
  );
}

export function useSidebarIsOpenState({
  contentType,
  objectId,
  widgetName,
}: Partial<DashboardIsOpenPayloadType>) {
  const key = `${contentType} ${objectId} ${widgetName}`;
  // default true because why not?
  return useSelector((state) => state.settings.sidebarIsOpen[key] ?? true);
}

export function useToggleWidgetIsOpen() {
  const dispatch = useDispatch();
  return (props: WidgetIsOpenPayloadType) =>
    dispatch(toggleWidgetIsOpen(props));
}

export function useToggleSidebarIsOpen() {
  const dispatch = useDispatch();
  return (props: DashboardIsOpenPayloadType) =>
    dispatch(toggleSidebarIsOpen(props));
}
